import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "sidebar__header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sidebar__header_logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "image is-24x24 is-rounded",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "sidebar__header_title" }, "Агентская программа")
], -1)
const _hoisted_2 = { class: "sidebar__list" }
const _hoisted_3 = { class: "sidebar__list_title" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "sidebar__list_title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "sidebar__list_chevron fa fa-chevron-down" }, null, -1)
const _hoisted_7 = {
  key: 2,
  class: "sidebar__sub-list"
}
const _hoisted_8 = { class: "sidebar__sub-list_title" }
const _hoisted_9 = { class: "sidebar__toggle" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "sidebar__toggle_icon fa fa-chevron-left" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", { 'is-reduced': _ctx.isReduced }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebarItems, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "sidebar__list_item-with-sub",
          key: item.name
        }, [
          (!item.items.length)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: _normalizeClass(["sidebar__list_item", { 'is-active': item.active }]),
                to: item.link
              }, {
                default: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(["sidebar__list_icon fas", `fa-${item.icon}`])
                  }, null, 2),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(item.display_name), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["sidebar__list_item", { 'is-active': item.active }]),
                onClick: ()=>_ctx.toggleItemActive(item)
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["sidebar__list_icon fas", `fa-${item.icon}`])
                }, null, 2),
                _createElementVNode("span", _hoisted_5, _toDisplayString(item.display_name), 1),
                _hoisted_6
              ], 10, _hoisted_4)),
          (item.items.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (sub) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    class: _normalizeClass(["sidebar__sub-list_item", { 'is-active': sub.active }]),
                    key: sub.name,
                    to: sub.link
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(sub.display_name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: "sidebar__toggle_button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
      }, _hoisted_11)
    ])
  ], 2))
}